import React from "react"
import { NavLink, Link } from "react-router-dom"
import {
  Home,
  Info,
  FileCode,
  List,
  Search,
  Github,
  Leaf,
  Linkedin,
  Link as LinkIcon,
} from "lucide-react"

import "./header.css"
import logo from "../../assets/Images/general/Photo_Profile.jpg"

const ICON_SIZE = 20
const ICON_STROKE = 1.75

export default function Header({ isNavPhoneVisible, setFalse }) {
  return (
    <header
      id={isNavPhoneVisible ? "sidebar" : "sidebarHide"}
      className="d-flex flex-column align-items-center"
    >
      {/* PROFILE */}
      <div className="profile-wrapper align-items-center">
        <Link to="/home" id="avatar" className="rounded-circle" onClick={setFalse}>
          <img src={logo} width="112" height="112" alt="avatar" />
        </Link>

        <div className="site-title">
          <Link to="/home" onClick={setFalse}>
            Arturo César Morales Montaño | TYNIP | - Portfolio
          </Link>
        </div>

        <div className="site-subtitle">
          Exploring Life Together.
          <br />
          Tech For Everyone
        </div>
      </div>

      {/* NAV */}
      <nav role="presentation">
        <ul className="nav flex-column flex-grow-1 w-100 ps-0">

          <NavItem to="/home" icon={Home} label="Home" onClick={setFalse} />
          <NavItem to="/about" icon={Info} label="About" onClick={setFalse} />
          <NavItem to="/projects" icon={FileCode} label="Projects" onClick={setFalse} />
          <NavItem to="/extracurricular" icon={List} label="Extracurricular" onClick={setFalse} />
          <NavItem to="/search" icon={Search} label="Search" onClick={setFalse} />

        </ul>

        {/* FOOTER */}
        <div className="sidebar-bottom d-flex flex-wrap align-items-center w-100">
          <a href="https://github.com/TYNIP" target="_blank" rel="noreferrer">
            <Github size={20} />
          </a>

          <a href="https://www.linkedin.com/in/arturo-cesar-morales-montano/" target="_blank" rel="noreferrer">
            <Linkedin size={20} />
          </a>

          <a href="https://linktr.ee/artmoram" target="_blank" rel="noreferrer">
            <LinkIcon size={20} />
          </a>

          <a href="https://ecotivista.com/profile/tynip" target="_blank" rel="noreferrer">
            <Leaf size={20} />
          </a>
        </div>

        <div id="personal">
          <p>
            artmoram.com ©{new Date().getFullYear()}
            <br />
            Arturo César Morales Montaño
          </p>
        </div>
      </nav>
    </header>
  )
}

/* -------------------------------- */
/* NAV ITEM COMPONENT */
/* -------------------------------- */

function NavItem({ to, icon: Icon, label, onClick }) {
  return (
    <li className="nav-item">
      <NavLink
        to={to}
        onClick={onClick}
        className={({ isActive }) =>
          `nav-link ${isActive ? "active" : ""}`
        }
      >
        <span className="nav-icon">
          <Icon size={ICON_SIZE} strokeWidth={ICON_STROKE} />
        </span>
        <span>{label}</span>
      </NavLink>
    </li>
  )
}
